import React from "react";
import CommonLayout from "./CommonLayout";
import moment from "moment/moment";
import { orderBy } from "lodash";
import ButtonSecondary from "../../shared/Button/ButtonSecondary";
import { useLocations } from "../../hooks/collections/useLocations";
import useModal from "../../@shared/components/Modal/hooks/useModal";
import ButtonPrimary from "../../shared/Button/ButtonPrimary";
import { AccountLocationForm } from "../AccountPage/ServiceForm/AccountLocationForm";
import { NotFound } from "../../components/NotFound/NotFound";

const AccountCompanyLocations = ({ className = "" }) => {
  const { locations } = useLocations(true);
  const modal = useModal();

  const handleOpenLocationForm = (location?: any) => {
    modal.open({
      title: location ? "Edit Location" : "Create Location",
      content: <AccountLocationForm location={location}/>,
      size: "lg"
    });
  };

  const renderSection1 = () => {
    return (
      <div className="space-y-6 sm:space-y-8">
        <div className="flex flex-col md:flex-row gap-5 items-center justify-between">
          <h2 className="text-3xl font-semibold">Company Locations</h2>
          <ButtonPrimary
            onClick={() => handleOpenLocationForm()}
          >New location</ButtonPrimary>
        </div>
        <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
        <div className={"overflow-x-auto"}>
          {locations.length ? (
            <table className={"w-full text-left min-w-[1000px] border-separate border-spacing-4"}>
              <thead>
              <tr>
                <th>Name</th>
                <th>Address</th>
                <th>Created At</th>
                <th></th>
              </tr>
              </thead>
              <tbody>
              {orderBy(locations, ["createdAt"], ["desc"]).map((location: any) => (
                <tr key={location.id}>
                  <td>{location.name}</td>
                  <td>{location.address}</td>
                  <td>{moment(location.createdAt).format("YYYY-MM-DD")}</td>
                  <td>
                    <ButtonSecondary onClick={() => handleOpenLocationForm(location)}>Edit</ButtonSecondary>
                  </td>
                </tr>
              ))}
              </tbody>
            </table>
          ) : (
            <NotFound description={"No locations found for your company."} />
          )}
        </div>
      </div>
    );
  };

  return (
    <div>
      <CommonLayout>{renderSection1()}</CommonLayout>
    </div>
  );
};

export default AccountCompanyLocations;
